import { Notice } from '@/shared/ui'

export const PaymentNotice = () => {
  return (
    <div className="px-6">
      <Notice.Title />
      <Notice.List>
        <Notice.Item>
          법인카드 결제에 문제가 있을 시 고객센터로 문의해 주세요.
        </Notice.Item>
      </Notice.List>
    </div>
  )
}
